/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Export_Logs_AriaInputs */

const en_drastic_tech_export_logs_aria = /** @type {(inputs: Drastic_Tech_Export_Logs_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Logs`)
};

const fr_drastic_tech_export_logs_aria = /** @type {(inputs: Drastic_Tech_Export_Logs_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter les journaux`)
};

const de_drastic_tech_export_logs_aria = /** @type {(inputs: Drastic_Tech_Export_Logs_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokolle exportieren`)
};

const it_drastic_tech_export_logs_aria = /** @type {(inputs: Drastic_Tech_Export_Logs_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta registri`)
};

const ru_drastic_tech_export_logs_aria = /** @type {(inputs: Drastic_Tech_Export_Logs_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журналы экспорта`)
};

const es_drastic_tech_export_logs_aria = /** @type {(inputs: Drastic_Tech_Export_Logs_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar registros`)
};

const zh_cn2_drastic_tech_export_logs_aria = /** @type {(inputs: Drastic_Tech_Export_Logs_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出日志`)
};

const ja_drastic_tech_export_logs_aria = /** @type {(inputs: Drastic_Tech_Export_Logs_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログのエクスポート`)
};

const hi_drastic_tech_export_logs_aria = /** @type {(inputs: Drastic_Tech_Export_Logs_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉग निर्यात करें`)
};

const pt_pt2_drastic_tech_export_logs_aria = /** @type {(inputs: Drastic_Tech_Export_Logs_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar registros`)
};

/**
* | output |
* | --- |
* | "Export Logs" |
*
* @param {Drastic_Tech_Export_Logs_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_export_logs_aria = /** @type {((inputs?: Drastic_Tech_Export_Logs_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Export_Logs_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_export_logs_aria(inputs)
	if (locale === "de") return de_drastic_tech_export_logs_aria(inputs)
	if (locale === "it") return it_drastic_tech_export_logs_aria(inputs)
	if (locale === "ru") return ru_drastic_tech_export_logs_aria(inputs)
	if (locale === "es") return es_drastic_tech_export_logs_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_export_logs_aria(inputs)
	if (locale === "ja") return ja_drastic_tech_export_logs_aria(inputs)
	if (locale === "hi") return hi_drastic_tech_export_logs_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_export_logs_aria(inputs)
	return en_drastic_tech_export_logs_aria(inputs)
});